// extracted by mini-css-extract-plugin
module.exports = {"bigHomeContainer":"layoutIndex-module--bigHomeContainer--1429G","titleContainer":"layoutIndex-module--titleContainer--3ETU4"};